import { createContext } from 'react'
import type { UseResearchSimplifiedReturn } from '@/types'

export const researchContext = createContext<
  UseResearchSimplifiedReturn | undefined
>(undefined)
